import React from 'react';

import tr from '../localization/translate';

import Flexmargin from '../common/Flexmargin';
import RoundedButton from '../common/RoundedButton';
import Spacer from '../common/Spacer';

import ufo from '../assets/images/ufo.svg';
import igglo from '../assets/images/igglo-logo.svg';
import s from './LostPage.scss';
import TrTitle, { PageCategories } from '../common/TrTitle';

const linkClassNames = `text effra watermelon no_decor ${s.link}`;

function LostPage() {
  return (
    <div>
      <TrTitle
        category={PageCategories.ROOT}
        name="Lost page"
        title="lost_page"
      />

      <header styleName="header">
        <Flexmargin />

        <div styleName="header_content">
          <a href="https://igglo.com">
            <img role="presentation" styleName="logo" src={igglo} />
          </a>

          <Spacer />

          <a href="https://igglo.com/vuokranantajat" className={linkClassNames}>
            { tr('simple_pages.lost_page.become_landlord_link') }
          </a>

          <a href="https://igglo.com/vuokralaiset" className={linkClassNames}>
            { tr('simple_pages.lost_page.for_tenants_link') }
          </a>

          <a href="https://igglo.com/asiakaspalvelu/" className={linkClassNames}>
            { tr('simple_pages.lost_page.support_link') }
          </a>

          <RoundedButton
            styleName="download_button"
            to="https://igglo.com/#heading-2d7973f2f23fbdabded0ad750c5aa085"
            rawLink
          >
            { tr('simple_pages.lost_page.download_button') }
          </RoundedButton>
        </div>

        <Flexmargin />
      </header>

      <main styleName="main">
        <Flexmargin />

        <div styleName="main_content">
          <div styleName="texts">
            <h2 className="title_sub center_on_mobile">
              { tr('simple_pages.lost_page.error_code') }
            </h2>

            <h1 className="title_top top_margin_30 center_on_mobile">
              { tr('simple_pages.lost_page.title') }
            </h1>

            <p className="text tallish_lines top_margin_30 center_on_mobile">
              { tr('simple_pages.lost_page.body') }
            </p>

            <RoundedButton to="https://igglo.com" className="top_margin_30" rawLink>
              { tr('simple_pages.lost_page.home_page_button') }
            </RoundedButton>
          </div>

          <div styleName="ufo_container">
            <img role="presentation" styleName="ufo_img" src={ufo} />
          </div>
        </div>

        <Flexmargin />
      </main>
    </div>
  );
}

export default LostPage;
